import { NavLink } from 'react-router-dom'

import styled, { css } from 'styled-components'

import { buttonDefaultStyles, buttonTemplates } from '../templates'

export const Container = styled(NavLink)<ContainerProps>`
  ${({ theme, template = 'primary', ...rest }) => {
    const buttonTemplate = buttonTemplates[template] || buttonTemplates.primary
    return css`
      ${buttonDefaultStyles({ theme, props: { ...rest } })}
      ${buttonTemplate?.({ theme, ...rest })}
    `
  }}
`
